import styled from 'styled-components';

export const Container = styled.div`
  .bidder-consideration-textarea {
    min-height: 140px;
    resize: vertical;
    width: 100%;
    box-sizing: border-box;
  }

  .bidder-consideration-my-section {
    width: 100%;
    min-width: 0;
  }

  /* Alinha ao padding superior de .summary-accordion-body (0.875rem 1.5rem) */
  .bidder-consideration-editor-lead {
    margin-bottom: 0.875rem;
  }

  .bidder-consideration-actions-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    width: 100%;
    margin-top: 0.75rem;
    box-sizing: border-box;
  }

  .bidder-consideration-actions-row__meta {
    flex: 1 1 auto;
    min-width: 0;
  }

  .bidder-consideration-actions-row__buttons {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 0.25rem;
    flex: 0 1 auto;
    min-width: 0;
    max-width: 100%;
  }

  .bidder-consideration-save-btn {
    flex: 0 0 auto;
    white-space: nowrap;
  }

  .bidder-consideration-delete-btn {
    display: inline-flex;
    align-items: center;
    flex: 0 0 auto;
    white-space: nowrap;
  }

  .bidder-consideration-char-count {
    line-height: 1.2;
    user-select: none;
  }

  .bidder-consideration-team-section {
    margin-top: 1.5rem;
  }

  .bidder-consideration-team-entries {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .bidder-consideration-team-card {
    background: #f4f6f8;
    border-radius: 8px;
    padding: 1rem 1.125rem;
    border: 1px solid rgba(0, 0, 0, 0.06);
  }

  .bidder-consideration-team-card__body {
    white-space: pre-wrap;
    word-break: break-word;
    font-size: 0.9375rem;
    line-height: 1.5;
  }

  .bidder-consideration-mine-header {
    gap: 0.5rem;
    margin-bottom: 0.875rem;
  }

  .bidder-consideration-team-heading {
    margin-bottom: 0.875rem;
  }

  .bidder-consideration-edit-link {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    color: ${(props) => props.theme.$primary};
    font-weight: 500;
    text-decoration: none;
    white-space: nowrap;

    &:hover,
    &:focus {
      color: ${(props) => props.theme.$primary};
      text-decoration: underline;
    }

    &:disabled {
      opacity: 0.5;
    }
  }

  .bidder-consideration-edit-icon {
    font-size: 1.125rem;
    line-height: 1;
    margin-right: 0.25rem;
    vertical-align: middle;
  }

  .bidder-consideration-mine-readonly {
    margin-bottom: 0;
  }
`;
